// Insights tab restyle (visual-only): outlined-card border/radius/shadow tokens shared by
// SectionCard, MetricCard, and UtilizationProgressCard - the three Insights cards that need
// this exact appearance (rule-of-three: worth a shared module once a third caller needed the
// same values, per CC-005).
//
// These previously lived as a GLOBAL `MuiCard`/`MuiCardContent` theme default in `theme.ts`.
// `defaultProps: { variant: 'outlined' }` there applied to every `<Card>` in the app, not just
// Insights - it overrode `elevation={0}` on unrelated screens (Organization Info's transparent
// outer wrapper in particular) and shifted `CardContent` padding on every other card by 4px.
// Do NOT move these back into `theme.ts`/`MuiCard`/`MuiCardContent` - that is exactly the
// app-wide regression this module exists to prevent. Each Insights card applies `variant`,
// these tokens, and its own padding locally via its own `sx` instead.
export const INSIGHTS_CARD_BORDER_COLOR = '#E5E7EB';
export const INSIGHTS_CARD_BORDER_RADIUS = 10; // px
export const INSIGHTS_CARD_BOX_SHADOW = '0 1px 2px rgba(16, 24, 40, 0.05)';
